import { Strings } from "src/modules/utils/shared/strings";
import { Utils } from "src/modules/utils/shared/utils";
import { CalendarOutlineEvent } from "../netgen/CalendarOutlineEvent";

export class CalendarOutlineTemplateGuiRow {
    path: string;
    pathItems: number[];
    event: CalendarOutlineEvent;

    private guid: string = null;

    constructor(path: string, event: CalendarOutlineEvent) {
        this.event = event;
        this.setPath(path);
    }

    setPath(path: string): void {
        this.path = path;
        this.pathItems = (this.event != null ? Strings.split(this.event.structurePath, "|") : path == null ? [] : Strings.split(path, "|")).map(item => Utils.toNumber(item));
    }

    isRoot(): boolean {
        return this.path == "";
    }

    isOutline(): boolean {
        return this.path != null;
    }

    isRealOutline(): boolean {
        return this.isOutline() && !this.isRoot();
    }

    isTemplate(): boolean {
        return this.path == null;
    }

    getLevel(): number {
        return this.pathItems.length + (this.isOutline() ? 0 : 1);
    }

    getLastPath(): number {
        return this.pathItems[this.pathItems.length - 1];
    }

    getOutlineElement(): number {
        return this.isOutline() ? this.getLastPath() : this.event.templateId;
    }

    getRowId(): string {
        return (this.path ?? "") + (this.isTemplate() ? "^" + (this.event.id > 0 ? this.event.id : this.getGuid()) : "");
    }

    getGuid(): string {
        this.guid ??=  Utils.getRandomHash();
        return this.guid; 
    }

} 